export const INSPECTIFY_PHONE_NUMBER = '8552716876';
export const INSPECTIFY_PHONE_NUMBER_FORMATTED = '1 (855) 271-6876';
export const INSPECTIFY_PHONE_NUMBER_LINK = 'tel:855-271-6876';
export const BETTER_INSPECT_PHONE_NUMBER = '8552716922';
export const BETTER_INSPECT_PHONE_NUMBER_FORMATTED = '1 (855) 271-6922';
export const BETTER_INSPECT_PHONE_NUMBER_LINK = 'tel:855-271-6922';
